import * as React from "react";
import { UitkLayoutGrid } from "uitk-react-layout-grid";
import { UitkText } from "uitk-react-text";
import { UitkSpacing } from "uitk-react-spacing";
import { decorateEditorialHtml } from "../../../../ContentUtilities";
import { EditorialModel } from "src/typings/microserviceModels/content-flex-module";

export const CitiHeaderSection = (props: { items: EditorialModel[] }) => {
  const { items } = props;
  if (items.length !== 2) {
    return null;
  }

  return (
    <UitkLayoutGrid space="two">
      <UitkText size={600} align="center" weight="bold">
        <UitkSpacing padding={{ blockstart: "four" }}>
          <div dangerouslySetInnerHTML={decorateEditorialHtml(items[0].text)} />
        </UitkSpacing>
      </UitkText>

      <UitkText align="center" size={300} weight="regular">
        <div className="all-b-padding-six" dangerouslySetInnerHTML={decorateEditorialHtml(items[1].text)} />
      </UitkText>
    </UitkLayoutGrid>
  );
};
export default CitiHeaderSection;
